module.exports = __webpack_public_path__ + "static/media/smartphone.97724b67.svg";